// Cognito/auth errors expose a `code` discriminator (amazon-cognito-identity-js).
interface CognitoLikeError {
  code?: string;
  message?: string;
}

export function mapSignInApiErrors(error: CognitoLikeError): string {
  let message: string = "";

  switch (error.code) {
    case "UserNotConfirmedException":
      message = "User has not been confirmed";
      break;

    case "NotAuthorizedException":
      message = "Invalid credentials";
      break;

    default:
      message = "Unknown error. Please try again";
      break;
  }

  return message;
}
